import { addClass, removeClass, toggleClass } from "../_vars";

export const takeTabs = () => {
    const switchers = document.querySelectorAll(".take-item");
    const content = document.querySelectorAll(".take__list");
    switchers.forEach((switcher, index) => {
        switcher.addEventListener("click", () => {
            switchers.forEach((s) => removeClass(s, "--active"));
            content.forEach((c) => removeClass(c, "--active"));
            addClass(switcher, "--active");
            addClass(content[index], "--active");
        });
    });
};
